// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"6197a767","356":"65c8afa7","484":"65c8afa7","500":"65c8afa7","554":"6197a767","593":"65c8afa7","595":"65c8afa7","757":"64595c27","769":"65c8afa7","788":"65c8afa7","791":"65c8afa7","998":"6197a767"}[chunkId] + ".chunk.css";
};